var map = {
	"./arabic.json": 613,
	"./bulgarian.json": 614,
	"./czech.json": 615,
	"./denmark.json": 616,
	"./english.json": 617,
	"./finnish.json": 618,
	"./greek.json": 619,
	"./indonesian.json": 620,
	"./malay.json": 621,
	"./norwegian.json": 622,
	"./romanian.json": 623,
	"./slovakia.json": 624,
	"./swedish.json": 625,
	"./thai.json": 626
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;


//////////////////
// WEBPACK FOOTER
// ./src/locales/funplus ^\.\/.*\.json$
// module id = 158
// module chunks = 0